import { useAuth } from './useAuth'

/**
 * True para usuários que não devem editar/criar/deletar processos, documentos
 * e demais entidades operacionais.
 *
 * Cobre:
 *   - Visualizador interno (estagiário/audit)
 *   - Qualquer usuário externo (cliente)
 *
 * Espelha o gate equivalente do backend (`ability.factory.ts`):
 * `!capsHas(caps, 'can_edit_own_records')`. Tipo de cliente e Visualizador não
 * têm `can_edit_own_records`.
 *
 * Sem `empresas`: read-only se não edita em NENHUMA empresa (união — menu,
 * planilha). Com `empresas` (tela de processo: `[p.company_id,
 * p.process_type?.company_id]`): o vínculo nelas decide (permissão é do vínculo).
 *
 * Permissões adicionais para subset de externos (export, update priority_level)
 * NÃO afetam read-only — vêm via hasCap individualmente.
 */
export const useIsReadOnlyUser = (
  empresas?: Array<number | string | null | undefined> | number | string | null
): boolean => {
  const { hasCap, hasCapIn } = useAuth()
  if (empresas === undefined) return !hasCap('can_edit_own_records')
  return !hasCapIn(empresas, 'can_edit_own_records')
}
